import React from 'react';
import { Link } from 'react-router-dom';
import { User, CreditCard, Sparkles } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Страница профиля: email, план подписки, переход в Billing.
 */
const Profile: React.FC = () => {
  const { isAuthenticated, isPro, email } = useAuth();

  if (!isAuthenticated) {
    return (
      <div className="content">
        <div className="container mx-auto px-4 py-12 max-w-xl">
          <div
            className="billing-auth-card rounded-2xl p-8 text-center border"
          >
            <User className="w-12 h-12 text-brand-gold mx-auto mb-4 opacity-90" />
            <h2 className="text-xl font-bold text-white mb-2">Profile</h2>
            <p className="text-white/70 mb-6">Log in to view your profile.</p>
            <Link to="/login?redirect=/profile" className="btn btn-gold inline-flex items-center gap-2">
              Log in / Join
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="content">
      <div className="container mx-auto px-4 py-8 pb-16 sm:pb-24 max-w-xl">
        <h1 className="text-3xl font-bold text-white mb-6">Profile</h1>

        <div
          className={`profile-plan-card rounded-2xl p-6 sm:p-8 border ${isPro ? 'profile-plan-card--pro' : 'profile-plan-card--free'}`}
        >
          <div className="flex items-start gap-4">
            <div
              className="profile-icon-wrap w-12 h-12 rounded-xl flex items-center justify-center shrink-0"
            >
              <User className="w-6 h-6" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-white/60 text-sm mb-1">Email</p>
              <p className="text-white font-medium truncate">{email}</p>
              <div className="mt-3 flex items-center gap-2">
                {isPro ? (
                  <span
                    className="profile-plan-badge profile-plan-badge--pro inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-bold text-black"
                  >
                    <Sparkles className="w-4 h-4" />
                    Premium
                  </span>
                ) : (
                  <span
                    className="profile-plan-badge profile-plan-badge--free inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-semibold"
                  >
                    FREE
                  </span>
                )}
              </div>
            </div>
          </div>

          <Link
            to="/billing"
            className="mt-6 flex items-center gap-2 px-4 py-3 rounded-lg font-medium text-white/90 hover:text-white transition border border-white/20 hover:border-white/30"
          >
            <CreditCard className="w-5 h-5 text-brand-gold" />
            Manage subscription & billing
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Profile;
